var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_2001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8286 20C40.8286 8.95431 31.8742 0 20.8285 0C9.7828 0 0.828491 8.95431 0.828491 20C0.828491 29.9826 8.14221 38.2567 17.7035 39.7571V25.7813H12.6254V20H17.7035V15.5938C17.7035 10.5813 20.6894 7.81252 25.2578 7.81252C27.446 7.81252 29.7348 8.20314 29.7348 8.20314V13.125H27.2128C24.7283 13.125 23.9536 14.6667 23.9536 16.2484V20H29.5004L28.6137 25.7813H23.9535V39.7571C33.5148 38.2567 40.8286 29.9826 40.8286 20Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6137 25.7813L29.5004 20H23.9535V16.2483C23.9535 14.6667 24.7283 13.125 27.2128 13.125H29.7348V8.20312C29.7348 8.20312 27.446 7.8125 25.2578 7.8125C20.6893 7.8125 17.7035 10.5812 17.7035 15.5938V20H12.6254V25.7813H17.7035V39.7571C18.7373 39.9191 19.7821 40.0003 20.8285 40C21.8916 40 22.9352 39.9168 23.9535 39.7571V25.7813H28.6137Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_2001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.828491)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.dc38dec4b50ce41f773700ea27f4e4b7.svg";
export { ForwardRef as ReactComponent };